// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
// import Vue from "vue/dist/vue.common.js";
import 'babel-polyfill'
import Es6Promise from 'es6-promise'
import App from "./App";
import router from "./router/index";
import store from "./managers/vuex/store";
import Keys from "./managers/storage/storage-key";
import Local from "./managers/storage/local";
import Session from "./managers/storage/session";
import MainConfig from "./main-config";
import Permission from "./managers/vue_extend/permission.js";
import VeeValidate from "./managers/validate/index";
import VueSelect2 from "./components/utility/vue-select2.vue";
import GlobalTool from "./managers/utils/global-tool";
// import WebSocketWrapper from './apis/ents'
import "./assets/css/site.scss";
import Advice from './assets/js/notify.js';
import './managers/utils/permission';
import nprogress from 'nprogress';
nprogress.configure({showSpinner: false});
// 百度地图
// import BaiduMap from 'vue-baidu-map'
require("setimmediate");

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(VeeValidate.VeeValidate, VeeValidate.config);
Vue.use(ElementUI, { size: 'small' });
// Vue.use(BaiduMap, { ak: 'gTGPLI5xKMjh6A4XHTWaoZwQc2EFb66b' });

xhook.before(function (request) {
  nprogress.start();
  if (window.session) {
    if (!request.headers.token) {
      if (request.url.indexOf(MainConfig.url.http) >= 0) {
        request.xhr.setRequestHeader('token', window.session.get(window.sessionKeys.TOKEN));
      }
    }
  }
});
xhook.after(function (request, response) {
  nprogress.done();
  if (response.status === 0) {  //后台服务没启动
      toast.alert({
        title: '提示信息！',
        type: 'error',
        text: "无法访问服务器，请刷新页面",
        onClose: function () {
        }
      });
      return;
  }
  if (response.status === 401) {  // token已过期
    toast.alert({
      title: '提示信息！',
      type: 'error',
      text: "会话失效或者操作超时, 请点击确定重新登录",
      onClose: function () {
        if(window.parent !== window) {
          const data = {
            type: 'EXPIRE'
          }
          window.parent.postMessage(data, 'http://localhost:5173');
          window.parent.postMessage(data, 'http://monitor.szdatie.com:10214');
        }
        sessionStorage.clear();
        window.location.reload();
        router.replace('/login');
      }
    });
    return;
  }
});

// const pushEvents = new WebSocketWrapper("ws://monitor.szdatie.com:10202/ws/v1/event");

window.local = Local;
window.session = Session;
window.localKeys = Keys.LocalKeys;
window.sessionKeys = Keys.SessionKeys;
window.mainConfig = MainConfig;
window.globalTool = GlobalTool;
// window.pushEvents = pushEvents;
window.advice = Advice;
Permission.accountType(Vue);
Permission.organizationType(Vue);
Vue.config.productionTip = false;
Vue.component('vue-select2', VueSelect2);
Es6Promise.polyfill()

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {App},
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js